module.exports = __webpack_public_path__ + "img/pink_cloud_right_end.51308e0f.svg";